import {
    GET_LOCATIONS_REQUEST,
    GET_LOCATIONS_SUCCESS,
    GET_LOCATIONS_FAILURE,
    ADD_PREVIEW_LOCATIONS,
    POST_LOCATIONS_SUCCESS,
    REMOVE_PREVIEW_LOCATIONS
} from '../constants/';

const INIT_STATE = {
    isLoading: false,
    isInitialFetch: true,
    data: [],
    error: null,
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LOCATIONS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_LOCATIONS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.locations,
                isInitialFetch: false,
            };
        case GET_LOCATIONS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
        case ADD_PREVIEW_LOCATIONS:
            {
                const newLocations = action.payload.locations.map((d) => ({ ...d, isDisabled: true, csvUploaded: true }));
                return {
                    ...state,
                    data: [...newLocations, ...state.data],
                };
            }
        case REMOVE_PREVIEW_LOCATIONS: {
            return {
                ...state,
                data: state.data.filter((f) => !f.isDisabled && !f.csvUploaded),
            };
        }

        case POST_LOCATIONS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.locations,
                isInitialFetch: false,
            };
        default:
            return state;
    }
};